/**
 * Checks if the given value is a class definition (constructor).
 * @param value - The value to check.
 * @returns True if the value is a class definition.
 */
export function isClassDefinition(value: any): boolean {
  return value.prototype !== undefined &&
    value.prototype.constructor !== undefined &&
    value.prototype.constructor.toString().startsWith("class");
}

/**
 * Checks if the given value is an instance of a class.
 * @param value - The value to check.
 * @returns True if the value is a class instance.
 */
export function isClassInstance(value: any): boolean {
  const proto = Object.getPrototypeOf(value);
  return proto.constructor
    && proto.constructor.toString().startsWith("class");
}
